var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
function SvgSuccess(props) {
    return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "17", viewBox: "0 0 16 17", fill: "none" }, props, { children: _jsx("path", { d: "M7.665 1.5C3.98259 1.5 1 4.48259 1 8.165C1 11.8441 3.98259 14.83 7.665 14.83C11.3441 14.83 14.33 11.8441 14.33 8.165C14.33 4.48259 11.3441 1.5 7.665 1.5ZM6.332 11.4975L2.9995 8.165L3.9426 7.2219L6.332 9.6113L11.3874 4.5559L12.3305 5.499L6.332 11.4975Z", fill: "#168104" }) })));
}
export default SvgSuccess;
